module.exports = __webpack_public_path__ + "img/dashiji-1988.e0d59961.jpg";